import { linkToListing } from "helpers/links-builders/listing";
import { getLang } from "helpers/themeHelpers";
import { ITagItem } from "models/tagKeywords";
import { slugifyHelper } from "helpers/textHelpers";
import {qsStringify} from "helpers/globalHelpers";

export const linkToTagsPage = (locale, slug: string = "") => {
  return `/${locale}/tags${slug?`/${slug}`: ""}`;
};
export const linkToTagDetails = (
  tagItem: ITagItem ,
  page = null,
  perPage = null,
  sort = null
) => {
  const locale = getLang();
  const params = qsStringify({page , perPage, sort });
  return `/${locale}/tags/${slugifyHelper(tagItem.tag)}${params}`;
};

export const linkToTagListing = (
  tagItem: ITagItem,
  { category = null, subCategory = null, city = null },
  page = null
) => {
  const locale = getLang();
  return `/${locale}/tags/${linkToListing(
    [city, category, subCategory],
    false,
    page
  )}`;
};
export const linkToTagCategory = (
  category = null,
  page = null,
  perPage = null
) => {
  const locale = getLang();
  const params = page ? `?page=${page}&per-page=${perPage}` : "";
  return `/${locale}/tags/category/${category}${params}`;
};
